import { Provider } from "@angular/core";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from "@angular/material/core";

export const snackBarOptions: Provider = {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: { duration: 5000, panelClass: 'break-all', verticalPosition: 'bottom' }
}

export const dialogOptions: Provider = {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: { width: '600px', maxWidth: '95vw', restoreFocus: false }
}

// AML-1096/1098: mat-timepicker defaults to the locale's 12-hour AM/PM display — every time on this
// admin screen is UTC and should read as an unambiguous 24-hour clock (0:00–23:59), so override just
// the time-related formats and keep the rest of the native date formats as-is.
export const nativeDateFormats24h: MatDateFormats = {
    ...MAT_NATIVE_DATE_FORMATS,
    parse: {
        ...MAT_NATIVE_DATE_FORMATS.parse,
        timeInput: { hour: 'numeric', minute: 'numeric', hour12: false },
    },
    display: {
        ...MAT_NATIVE_DATE_FORMATS.display,
        timeInput: { hour: 'numeric', minute: 'numeric', hour12: false },
        timeOptionLabel: { hour: 'numeric', minute: 'numeric', hour12: false },
    },
}
